<script lang="ts" context="module">
    import {registration, fetchOrigin} from "./data.ts";
    import {get, type Writable, writable} from "svelte/store";
    import {tick} from "svelte";

    let loading = writable(false);
    let last_result: Writable<boolean | undefined> = writable(undefined);
    let timeout: number | undefined = undefined;

    export async function save() {
        last_result.set(undefined)
        clearTimeout(timeout);
        loading.set(true);
        await tick();
        const result = await fetchOrigin('/registration', {'method': 'POST', 'body': JSON.stringify(get(registration))});
        const json = await result.json();
        if (json.success) {
            last_result.set(true);
        } else {
            last_result.set(false);
        }
        loading.set(false);
        timeout = setTimeout(() => last_result.set(undefined), 5000);
    }
</script>

<footer><button on:click={save} aria-busy={$loading ? 'true' : 'false'}>Save Registration {#if $last_result === true}✔{:else if $last_result === false}✖{/if}</button></footer>